var CustomForms = (function () {

    var validator;

    var $dom = {};

    return {
        init: function ($form) {
            $dom.form = $form;

            //console.log('Custom Form Validation started', $form);

            validator = $dom.form.validate({
                errorClass: 'adco-error',
                // onkeyup: function(element) {
                //     this.element(element);
                    // console.log('onkeyup fired');
                // },
                onfocusout: function(element) {
                    this.element(element);
                    // console.log('onfocusout fired');
                },
                lang: 'de'
            });
            $.extend($.validator.messages, {
                step: 'Bitte geben Sie nur ganze Zahlen ein.'
            });

        }
    };

});

jQuery(function ($) {

    $('form.js-validateFormViaJS').each(function (index, form) {
        CustomForms().init($(form));
    });

});
